import React from 'react'
import styled from 'styled-components'

import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const StyledUserGuide = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`
/**
 * A banner to alert users to a helpful instructional video and user guide document
 * 
 * @author Nicolete Ebner
 * @author Alex Clary
 */
const UserGuide = () =>
  <StyledUserGuide>
    <LgyAlertDialog type='info' heading='LGY Hub User Guide'>
      <span>Start with the&nbsp;
        <a target='_blank' rel='noopener noreferrer' href='https://www.benefits.va.gov/homeloans/documents/docs/lgy_hub_user_guide.pdf'>user guide</a>        
        &nbsp;to get more information about LGY Hub!</span>
    </LgyAlertDialog>
  </StyledUserGuide>

export default UserGuide